import { render, staticRenderFns } from "./SurveyBanner.vue?vue&type=template&id=2b4a7272&scoped=true&"
import script from "./SurveyBanner.vue?vue&type=script&lang=ts&"
export * from "./SurveyBanner.vue?vue&type=script&lang=ts&"
import style0 from "./SurveyBanner.vue?vue&type=style&index=0&id=2b4a7272&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b4a7272",
  null
  
)

export default component.exports